'use strict';

import { primaryOptions } from '../project-info/serviceInfo';

const slugs = primaryOptions.reduce(
  (obj, item) => ((obj[item.key] = item.value), obj),
  {},
);

export {slugs as MILITARY_STATUSES};
